module.exports = __webpack_public_path__ + "static/media/gardenCombo.196c8cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gardenCombo.jpg
// module id = 167
// module chunks = 0